module.exports = __webpack_public_path__ + "img/battleface.2c6010b8.png";